import $ from 'jquery';

$(function() {
  // Show more text option 
  var showChar = 340;  // How many characters are shown by default
  var ellipsestext = "...";
  var moretext = '<span class="cta--text">Show More</span><span class="cta--down-arrow-icon icon"></span>';
  var lesstext = '<span class="cta--text">Show Less</span><span class="cta--down-arrow-icon icon"></span>';
  
  //Cut content based on showChar length
  if ($(".cwm-account-manager-1_content .cwm-account-manager-1_text").length) {
      $(".cwm-account-manager-1_content .cwm-account-manager-1_text").each(function() {

          var content = $(this).html();
          console.log(content);
   
          if(content.length > showChar) {
   
              var contentExcert = content.substr(0, showChar);
              var contentRest = content.substr(showChar, content.length - showChar);
              var html = contentExcert+'<span class="cwm-toggle-text-ellipses">'+ellipsestext+'</span><span class="cwm-toggle-text-content"><span>' + contentRest + '</span> <a href="javascript:;" class="cwm-toggle-text-link">' + moretext + '</a></span>';
   
              $(this).html(html);
          }
      });
  }


  
  //Toggle content when click on read more link
  $(".cwm-account-manager-1_content .cwm-toggle-text-link").click(function(){
      if($(this).hasClass("less")) {
          $(this).removeClass("less");
          $(this).html(moretext);
      } else {
          $(this).addClass("less");
          $(this).html(lesstext);
      }
      $(this).parent().prev().toggle();
      $(this).prev().toggle();
      return false;
  });
});


// WEBPACK FOOTER //
// ./components/cwm-account-manager/scripts/_cwm-account-manager.js